import React, { useContext } from 'react';
import { SnackbarContext } from '@utils';
import { Snackbar } from 'gd-design-library';

export const AppSnackbar: React.FC = () => {
  const { snackbarParams: {
    open,
    message,
    onClose,
    severity = 'error'
  } } = useContext(SnackbarContext);

  return open && (
    <Snackbar
      onClose={ onClose }
      message={ message }
      duration={ 6000 }
      variant={ severity }
    />
  );
};
